export default __webpack_public_path__ + "static/media/358.689eb72e.jpg";